import { FC, useState } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { CheckoutDesign } from '../types';

import DesktopPreview from './DesktopPreview';
import MobilePreview from './MobilePreview';

export const TOTALS = [
  { label: 'Subtotal', value: '$ 13.25' },
  { label: 'Tax (17%)', value: '$ 2.25' },
  { label: 'Total', value: '$ 15.50', bold: true }
];

const PreviewSection: FC<CheckoutDesign> = ({
  logo,
  buttonColor,
  buttonTextColor,
  primaryColor,
  textColor,
  backgroundImage,
  mobileBgImage
}) => {
  const [isMobilePreview, setIsMobilePreview] = useState(true);

  const toolbarButtonClasses = (active: boolean) =>
    `text-[18px] w-8 h-8 cursor-pointer ${active ? 'text-indigo-300' : 'text-neutral-300'}`;

  return (
    <div className="w-1/2 bg-zinc-100 px-16 py-5">
      {/* Toolbar */}
      <div className="mb-11 flex items-center justify-between">
        <p className="text-[20px] font-semibold">Preview</p>
        <div className="flex items-center bg-white rounded-lg shadow border border-base-sidebarBorder p-1.5">
          <FontAwesomeIcon
            icon="fa-solid fa-mobile"
            className={toolbarButtonClasses(isMobilePreview)}
            onClick={() => setIsMobilePreview(true)}
          />
          <hr className="bg-base-border w-[1px] h-6 mx-1" />
          <FontAwesomeIcon
            icon="fa-regular fa-desktop"
            className={toolbarButtonClasses(!isMobilePreview)}
            onClick={() => setIsMobilePreview(false)}
          />
        </div>
      </div>

      {/* Preview */}
      <div className="flex gap-12 justify-center">
        {isMobilePreview ? (
          <MobilePreview
            logo={logo}
            buttonColor={buttonColor}
            buttonTextColor={buttonTextColor}
            primaryColor={primaryColor}
            textColor={textColor}
            backgroundImage={backgroundImage}
            mobileBgImage={mobileBgImage}
          />
        ) : (
          <DesktopPreview
            logo={logo}
            buttonColor={buttonColor}
            buttonTextColor={buttonTextColor}
            primaryColor={primaryColor}
            textColor={textColor}
            backgroundImage={backgroundImage}
          />
        )}
      </div>
    </div>
  );
};

export default PreviewSection;
